import {
  PERFORMANCE_LOADING,
  GET_PERFORMANCE,
  GET_PERFORMANCE_SUCCESS,
  GET_PERFORMANCE_FAIL,
  ADD_PERFORMANCE_SUCCESS,
  ADD_PERFORMANCE_FAIL,
  DELETE_PERFORMANCE_SUCCESS,
  DELETE_PERFORMANCE_FAIL,
  UPDATE_PERFORMANCE_SUCCESS,
  UPDATE_PERFORMANCE_FAIL,
  PERFORMANCE_RESET
} from "./actionType";

const INIT_STATE = {
  performances: [],
  error: {},
};

const Performance = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PERFORMANCE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PERFORMANCE:
          return {
            ...state,
            performances: action.payload.data,
            isPerformanceCreated: false,
            isPerformanceSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PERFORMANCE_FAIL:
      switch (action.payload.actionType) {
        case GET_PERFORMANCE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPerformanceCreated: false,
            isPerformanceSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PERFORMANCE: {
      return {
        ...state,
        isPerformanceCreated: false,
        loading: true,
      };
    }

    case PERFORMANCE_LOADING: {
      return {
        ...state,
        isPerformanceCreated: false,
        loading: true,
      };
    }

    case ADD_PERFORMANCE_SUCCESS:
      return {
        ...state,
        isPerformanceCreated: true,
        loading: false,
        performances: [action.payload.data, ...state.performances],
      };

    case ADD_PERFORMANCE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PERFORMANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        isPerformanceCreated: true,
        performances: state.performances.filter(
          performance => performance.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PERFORMANCE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PERFORMANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        isPerformanceCreated: true,
        performances: state.performances.map(performance =>
          performance.id.toString() === action.payload.data.id.toString() ? { ...performance, ...action.payload.data } : performance
        ),
      };

    case UPDATE_PERFORMANCE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PERFORMANCE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Performance;